import { Pipe, PipeTransform } from '@angular/core';
import { BusinessTrunk } from '@app/core/interfaces/c5/business-trunk';
import { TrunkCommon } from '@app/core/interfaces/trunk-common';
import { formatNumberRange } from '@app/utils/format-number-range';

@Pipe({
  name: 'portalTrunkName',
  pure: true,
  standalone: false,
})
export class TrunkNamePipe implements PipeTransform {
  transform(value: TrunkCommon | BusinessTrunk): string {
    if (value != null) {
      let trunk: BusinessTrunk;

      if ('db' in value) {
        trunk = value.c5;
      } else {
        trunk = value;
      }

      const systemRange = trunk.numberRanges.find((numberRange) => numberRange.systemRange);
      return formatNumberRange(systemRange);
    }

    return '';
  }
}
